// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7BKQ_","rootMobile":"styles_rootMobile__3ua3R"};